import { connect } from "react-redux";
import WorkAreaInput from "../../components/Engineering/WorkAreaInput";
import { applyWorkArea } from "../../actions/engineering";

const mapStateToProps = state => {
  return {
    panelPosition: state.preferences.DOCK_POSITION
  };
};

const mapDispatchToProps = dispatch => ({
  // changeValue: (name, val) => { console.log('change input: ' + name + ' to: ' +  val)},
  submit: (node, inputs) => dispatch(applyWorkArea(node, inputs))
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkAreaInput);
